import { KnowledgeHubWorkspaceNavRow } from './knowledge-hub-workspace-nav-row'
import { useKnowledgeHubQueueCounts } from '@/hooks/use-knowledge-hub-queue-counts'
import { useWorkspaceExtensions } from '@/hooks/use-workspace-extensions'

type Props = {
  workspaceId: string
  padLeft: number
  active: boolean
  expanded: boolean
  onToggleExpand: () => void
  icon: React.ReactNode
  label: string
  onSetTab: (tab: string) => void
  activeTabId?: string | null
  activeFilter?: 'review-requested' | 'needs-review' | null
}

/** Browse sidebar section wiring queue counts and navigation for Knowledge Hub. */
export function KnowledgeHubBrowseSection({
  workspaceId,
  padLeft,
  active,
  expanded,
  onToggleExpand,
  icon,
  label,
  onSetTab,
  activeTabId,
  activeFilter,
}: Props) {
  const { isExtensionEnabled } = useWorkspaceExtensions(workspaceId)
  const enabled = isExtensionEnabled('knowledge-hub')
  const { counts } = useKnowledgeHubQueueCounts(workspaceId, enabled)

  const openQueue = (filter?: 'review-requested' | 'needs-review') => {
    const tabId = filter === 'needs-review'
      ? `knowledge-hub-needs-review-${workspaceId}`
      : filter === 'review-requested'
        ? `knowledge-hub-review-queue-${workspaceId}`
        : `knowledge-hub-queue-${workspaceId}`
    onSetTab(`integration-knowledge-hub`)
    window.dispatchEvent(
      new CustomEvent('integration-view-change', {
        detail: {
          tabId,
          title: filter === 'needs-review' ? 'Needs review' : filter === 'review-requested' ? 'Review queue' : 'Knowledge Hub',
          type: 'integration-knowledge-hub',
          integrationData: {
            integrationId: 'knowledge-hub',
            organizationId: workspaceId,
            statusFilter: filter ?? null,
          },
        },
      })
    )
  }

  return (
    <KnowledgeHubWorkspaceNavRow
      workspaceId={workspaceId}
      padLeft={padLeft}
      active={active}
      expanded={expanded}
      onToggleExpand={onToggleExpand}
      icon={icon}
      label={label}
      reviewRequestedCount={counts.reviewRequested}
      needsReviewCount={counts.needsReview}
      onOpenQueue={() => openQueue()}
      onOpenReviewQueue={() => openQueue('review-requested')}
      onOpenNeedsReview={() => openQueue('needs-review')}
      activeFilter={activeFilter}
    />
  )
}
